import { montarUrlDaApi } from '../api/clienteHttp';

/** A URL de SESSÃO de um anexo de uma mensagem da thread (`AC9`): a triagem e as informações do Caso baixam por ela. */
export function urlDoAnexoDaThread(ticketId: string, emailId: string, anexoId: string): string {
  return montarUrlDaApi(
    `/triagem/${encodeURIComponent(ticketId)}/emails/${encodeURIComponent(emailId)}/anexos/${encodeURIComponent(anexoId)}`,
  );
}
